import React from "react";
import { Steps, Typography } from "antd";
import type { StepsProps } from "antd";
import type { LeanCustomsCreateStep, LeanCustomsCreateStepStatus } from "./leanCustomsCreateOrderSteps";

function mapStepStatus(status: LeanCustomsCreateStepStatus): StepsProps["status"] {
  switch (status) {
    case "done":
    case "skipped":
      return "finish";
    case "active":
      return "process";
    case "error":
      return "error";
    default:
      return "wait";
  }
}

export const LeanCustomsCreateOrderProgress: React.FC<{
  steps: LeanCustomsCreateStep[];
}> = ({ steps }) => {
  const activeIndex = steps.findIndex((s) => s.status === "active");
  const hasError = steps.some((s) => s.status === "error");
  const current = activeIndex >= 0 ? activeIndex : steps.filter((s) => s.status === "done" || s.status === "skipped").length;

  return (
    <div style={{ padding: "8px 4px 16px" }}>
      <Typography.Title level={5} style={{ marginTop: 0, marginBottom: 16 }}>
        Creating Lean Customs order
      </Typography.Title>
      <Typography.Paragraph type="secondary" style={{ marginBottom: 20, fontSize: 13 }}>
        Please keep this window open until all steps are complete.
      </Typography.Paragraph>
      <Steps
        direction="vertical"
        size="small"
        current={current}
        status={hasError ? "error" : "process"}
        items={steps.map((step) => ({
          title: step.label,
          description:
            step.status === "skipped"
              ? step.detail ?? "Skipped"
              : step.detail,
          status: mapStepStatus(step.status),
        }))}
      />
    </div>
  );
};
